
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/[slug]",
      function () {
        return require("private-next-pages/stories/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/[slug]"])
      });
    }
  